import Icon from '../components/Icon.vue'

Icon.register({
  'suitcase-rolling': {
    width: 384,
    height: 512,
    paths: [
      {
        d: 'M336 160c26.5 0 48 21.5 48 48v224c0 26.5-21.5 48-48 48h-16v16c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-16h-128v16c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-16h-16c-26.5 0-48-21.5-48-48v-224c0-26.5 21.5-48 48-48h288zM320 376v-16c0-4.4-3.6-8-8-8h-240c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h240c4.4 0 8-3.6 8-8zM320 280v-16c0-4.4-3.6-8-8-8h-240c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h240c4.4 0 8-3.6 8-8zM144 48v80h-48v-80c0-26.5 21.5-48 48-48h96c26.5 0 48 21.5 48 48v80h-48v-80h-96z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/suitcase-rolling.js
// module id = 1963
// module chunks = 0